import React from 'react'
import {FaUmbrellaBeach, FaBus, FaWater } from 'react-icons/fa'

export default [
{
    icon: <FaUmbrellaBeach />,
    title: 'Beach amenities',
    text: 'Complementary beach chair and towels.',
},
{
    icon: <FaBus />,
    title: 'Shuttle Service',
    text: 'Free local shuttle service.',
},
{
    icon: <FaWater />,
    title: 'Surf & Snorkel rental',
    text: 'Surf and snorkel equiptment rental on-site.',
},
]